// @flow

import { connect } from 'react-redux';
import type { State } from 'store/types';
import { bindActionCreators, type Dispatch } from 'redux';
import { withRouter } from 'react-router-dom';
import appActions from 'view/duck/actions';
import ProjectsList from './ProjectsList';

function mapStateToProps(state: State) {
  return {
    test: state.app.test,
    isDarkTheme: state.app.isDarkTheme,
  };
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  return {
    actions: bindActionCreators(
      {
        testAction: appActions.testAction,
      },
      dispatch,
    ),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectsList));



// WEBPACK FOOTER //
// ./src/view/screens/ProjectsList/index.js